import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'whatsappSessionId';

// Hook simple para gestionar sessionId persistido en localStorage.
export default function useWhatsappSessionId() {
  const [sessionId, setSessionId] = useState(() => localStorage.getItem(STORAGE_KEY) || null);

  const update = useCallback((id) => {
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
      setSessionId(id);
      console.log('[useWhatsappSessionId] sessionId set', id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
      setSessionId(null);
      console.log('[useWhatsappSessionId] sessionId cleared');
    }
  }, []);

  useEffect(() => {
    // Sincronización reactiva en caso otro tab modifique
    const handler = () => {
      const stored = localStorage.getItem(STORAGE_KEY);
      console.log('[useWhatsappSessionId] storage event detected, new value', stored);
      setSessionId(stored || null);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return { sessionId, setSessionId: update };
}
